import { styled, Box } from '@/theme/index';

export const StyledApiBox = styled(Box)(({ theme }) => ({
  borderBottom: '1px solid black',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > *': {
      marginBottom: theme.spacing(1),
    },
  },
}));

export const StyledApiEndBox = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'flex-end',
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 0,
    alignItems: 'flex-start',
  },
}));
